// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Custom navigation button styles */
.custom-swiper-button-prev,
.custom-swiper-button-next {
  position: absolute;
  top: 50%; /* Center vertically */
  transform: translateY(-50%);
  font-size: 32px; /* Adjust icon size */
  color: #ff9800; /* Arrow color */
  cursor: pointer;
  z-index: 10;
  transition: transform 0.2s ease-in-out;
}

/* Left Arrow */
.custom-swiper-button-prev {
  left: 10px;
}

/* Right Arrow */
.custom-swiper-button-next {
  right: 10px;
}

/* Hover effect */
.custom-swiper-button-prev:hover,
.custom-swiper-button-next:hover {
  transform: translateY(-50%) scale(1.2);
  color: #ff5722; /* Darker orange on hover */
}
`, "",{"version":3,"sources":["webpack://./src/Components/Common/Css/customSwiper.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;;EAEE,kBAAkB;EAClB,QAAQ,EAAE,sBAAsB;EAChC,2BAA2B;EAC3B,eAAe,EAAE,qBAAqB;EACtC,cAAc,EAAE,gBAAgB;EAChC,eAAe;EACf,WAAW;EACX,sCAAsC;AACxC;;AAEA,eAAe;AACf;EACE,UAAU;AACZ;;AAEA,gBAAgB;AAChB;EACE,WAAW;AACb;;AAEA,iBAAiB;AACjB;;EAEE,sCAAsC;EACtC,cAAc,EAAE,2BAA2B;AAC7C","sourcesContent":["/* Custom navigation button styles */\n.custom-swiper-button-prev,\n.custom-swiper-button-next {\n  position: absolute;\n  top: 50%; /* Center vertically */\n  transform: translateY(-50%);\n  font-size: 32px; /* Adjust icon size */\n  color: #ff9800; /* Arrow color */\n  cursor: pointer;\n  z-index: 10;\n  transition: transform 0.2s ease-in-out;\n}\n\n/* Left Arrow */\n.custom-swiper-button-prev {\n  left: 10px;\n}\n\n/* Right Arrow */\n.custom-swiper-button-next {\n  right: 10px;\n}\n\n/* Hover effect */\n.custom-swiper-button-prev:hover,\n.custom-swiper-button-next:hover {\n  transform: translateY(-50%) scale(1.2);\n  color: #ff5722; /* Darker orange on hover */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
